module.exports = __webpack_public_path__ + "static/BR-d336766d8b7b50eb4baa76aa90978944.png";